<template>
  <div class="sb-element">
    <div class="bto-sb-tost-notification"
      :class="{
        'bto-sb-tost-notifications-success': message.type === 1,
        'bto-sb-tost-notifications-error': message.type === 2,
        'bto-sb-tost-notifications-info': message.type === 3,
        'bto-sb-tost-notifications-warning': message.type === 4,
        }">
      <div class="bto-sb-tost-notification-title" @click="removeToast()">
        {{message.title}}
      </div>
      <div class="bto-sb-tost-notification-close" @click="removeToast()"><i class="bto-app-icon bto-app-delete"></i></div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'GenericToast',
    props: {
      message: {
        type: Object,
        required: true,
      },
    },
    methods: {
      removeToast() {
        this.$emit('removeToast');
      },
    },
  };
</script>